import { useEffect } from 'react';

const useBotmakerSpacer = (elem, breakpoint) => {
  const iframes = document.querySelectorAll('iframe');

  useEffect(() => {
    if (iframes.length > 0) {
      iframes.forEach(d => {
        if (d.getAttribute('name') === 'Botmaker') {
          elem.current.style.marginBottom = breakpoint ? '100px' : '';
        }
      });
    }
  }, [breakpoint, elem, iframes]);
};

const useBotmakerRecognizer = setBotmaker => {
  const iframes = document.querySelectorAll('iframe');

  useEffect(() => {
    if (iframes.length > 0) {
      iframes.forEach(d => {
        if (d.getAttribute('name') === 'Botmaker') {
          setBotmaker(true);
        }
      });
    }
  }, [setBotmaker, iframes]);
};

export { useBotmakerSpacer, useBotmakerRecognizer };
